import React from 'react';
import { PropTypes } from 'prop-types';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSave } from '@fortawesome/free-solid-svg-icons';
import LinkIcon from 'ui/LinkIcon';
import { FormattedMessage } from 'react-intl';

const Files = ({ files }) => {
   if (!files?.length) return null;
   const rendered = files.map((f) => {
      return (
         <Item key={Math.random()}>
            <Name>{f.name}</Name>
            <LinkIconRight href={f.url} targer="_blank">
               <FormattedMessage id="Download" />
               <FontAwesomeIcon icon={faSave} />
            </LinkIconRight>
         </Item>
      );
   });
   return (
      <Container>
         <Items>{rendered}</Items>
      </Container>
   );
};

const LinkIconRight = styled(LinkIcon)`
   & > .svg-inline--fa {
      margin-left: 1rem;
   }
`;

const Container = styled.div`
   margin-top: 2rem;
`;

const Name = styled.span`
   margin-right: 1rem;
`;

const Items = styled.ul`
   padding: 0;
`;

const Item = styled.li`
   list-style-type: none;
   display: flex;
   align-items: center;
`;

Files.propTypes = {
   files: PropTypes.arrayOf(
      PropTypes.shape({
         name: PropTypes.string.isRequired,
         url: PropTypes.string.isRequired
      })
   ).isRequired
};

export default Files;
